import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { referralFlowsActions } from 'features/referralFlows';

const useReferralFlows = () => {
  const dispatch = useDispatch();
  const getReferralFlow = useCallback(() => dispatch(referralFlowsActions.getReferralFlow()), [dispatch]);
  const createReferralFlow = useCallback(referral_flow => dispatch(referralFlowsActions.createReferralFlow(referral_flow)), [dispatch]);
  const updateReferralFlow = useCallback(referral_flow => dispatch(referralFlowsActions.updateReferralFlow(referral_flow)), [dispatch]);
  const deleteReferralFlow = useCallback(() => dispatch(referralFlowsActions.deleteReferralFlow()), [dispatch]);
  const clearLocalActiveReferralFlow = useCallback(() => dispatch(referralFlowsActions.clearLocalActiveReferralFlow()), [dispatch]);

  return {
    getReferralFlow,
    createReferralFlow,
    updateReferralFlow,
    deleteReferralFlow,
    clearLocalActiveReferralFlow
  };
};

export default useReferralFlows;